<template>
  <div>
    <div class="vl-parent">
      <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage"/>
   </div>
    <Uploader
      server="upload"
      @change="changeMedia"
      @remove="removeMedia"
      maxFilesize=10
      max=1
    />
    <br>
    <input type="text" class="form-control" placeholder="Image Caption" name="caption" v-model="caption">
  <br>
  <div class="input-group-append">
  <button @click="uplodimages()" class="file-upload-browse btn btn-info" type="button">Upload Image</button>
  </div>
</div>
</template>
<script>
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Uploader from "vue-media-upload";
export default {
    data() {
      return {
        media: [],
        images:[],
        fileToUpload: null,
        isLoading: false,
        fullPage: true,
        caption:'',
      }
    },
    computed:{
    url(){
      return this.$store.state.url;
    }
    },
    components: {
      Uploader,
      Loading
    },
    methods:{
      blobUrlToBase64(blobUrl, callback) {
      fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => {
            let reader = new FileReader();
            reader.onloadend = function() {
                let base64String = reader.result;
                callback(base64String);
            };
            reader.readAsDataURL(blob);
        })
        .catch(error => console.error('Error converting blob URL to base64', error));
      },
      changeMedia(media){
        this.images=[];
        this.media=media;
        console.log(this.media);
        this.media.forEach(media => {
        this.blobUrlToBase64(media.url, (base64String) => {
         this.images.push(base64String);
        });
       })


      },
      uplodimages(){
       this.isLoading=true;
       axios.post(this.url+'uploadimages',{
        images:this.images,
        caption:this.caption,
       }).then(response=>{
          this.isLoading=false;
          console.log(response.data);
          this.media=[];
          $('.mu-image-container').remove();
          toast.success("Image has uploaded successfully", {
          autoClose: 1000,
          transition:'zoom',
          position:'top-center'
          });
        })


    },
    removeMedia(removedImage, removedMedia){
        this.media.removed = removedMedia
      }
   }
  }
</script>